/* eslint-disable no-console*/
import _ from 'lodash';
import {
  QUERY_REQUEST,
  MUTATION_REQUEST,
  QUERY_FAILURE,
  MUTATION_FAILURE,
  QUERY_CONDOLENCES_SUCCESS,
  QUERY_GALLERY_SUCCESS,
  MUTATE_CONDOLENCE_SUCCESS,
  MUTATE_PERSON_ALERT_SUCCESS,
  MUTATE_PERSON_ALERT_FAILURE,
  RESET_MUTATION_STATUS,
  QUERY_LOCATION_SEARCH_SUCCESS,
  MUTATE_PERSON_UGC_SUCCESS,
  MUTATE_PERSON_UGC_FAILURE,
  MUTATE_LIKES_SUCCESS,
  MUTATE_LIKES_FAILURE,
  PERSON_STORE_HYDRATION,
} from '../actions';

/**
 * Updates the person store section of the state tree
 * @method  personStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */
export default function personStore(state = {loading: false}, action) {
  if (_.isNil(_.get(action, 'type'))) {
    return state;
  }

  switch (action.type) {
    /* query reducers */
    case QUERY_REQUEST:
      return Object.assign({}, state, {loading: true});

    case QUERY_FAILURE:
      console.log('a query failure has occured...', action.reason);
      return Object.assign({}, state, {loading: false});

    case QUERY_CONDOLENCES_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newCondolencesState = _.cloneDeep(state);
      const previousCondolences = _.get(
        newCondolencesState,
        'person.guestBook.condolences.edges'
      );
      const newCondolences = _.get(
        action,
        'response.data.guestBooks.condolences.edges'
      );

      const newPageInfo = {
        startCursor: _.get(
          action,
          'response.data.guestBooks.condolences.pageInfo.startCursor'
        ),
        endCursor: _.get(
          action,
          'response.data.guestBooks.condolences.pageInfo.endCursor'
        ),
        hasNextPage: _.get(
          action,
          'response.data.guestBooks.condolences.pageInfo.hasNextPage'
        ),
        hasPreviousPage: _.get(
          action,
          'response.data.guestBooks.condolences.pageInfo.hasPreviousPage'
        ),
      };

      _.set(newCondolencesState, 'person.guestBook.condolences.edges', [
        ...previousCondolences,
        ...newCondolences,
      ]);
      _.set(
        newCondolencesState,
        'person.guestBook.condolences.pageInfo',
        newPageInfo
      );
      _.set(newCondolencesState, 'loading', false);

      return newCondolencesState;

    case QUERY_GALLERY_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newGalleryState = _.cloneDeep(state);
      const previousGallery = _.get(
        newGalleryState,
        'person.guestBookGallery.condolences.edges',
        []
      );
      const newGallery = _.get(
        action,
        'response.data.guestBookGallery.condolences.edges'
      );

      const previousStartCursor = _.get(
        newGalleryState,
        'person.guestBookGallery.condolences.pageInfo.startCursor'
      );
      const newStartCursor = _.get(
        action,
        'response.data.guestBookGallery.condolences.pageInfo.startCursor'
      );

      if (previousStartCursor !== newStartCursor) {
        const galleryPageInfo = {
          startCursor: newStartCursor,
          endCursor: _.get(
            action,
            'response.data.guestBookGallery.condolences.pageInfo.endCursor'
          ),
          hasNextPage: _.get(
            action,
            'response.data.guestBookGallery.condolences.pageInfo.hasNextPage'
          ),
          hasPreviousPage: _.get(
            action,
            'response.data.guestBookGallery.condolences.pageInfo.hasPreviousPage'
          ),
        };

        _.set(newGalleryState, 'person.guestBookGallery.condolences.edges', [
          ...previousGallery,
          ...newGallery,
        ]);
        _.set(
          newGalleryState,
          'person.guestBookGallery.condolences.pageInfo',
          galleryPageInfo
        );
      }

      _.set(newGalleryState, 'loading', false);

      return newGalleryState;

    /* mutation reducers */
    case MUTATION_REQUEST:
      return Object.assign({}, state, {loading: true});

    case MUTATION_FAILURE:
      console.log('a mutation failure has occured...', action.reason);
      const failureState = _.cloneDeep(state);

      _.set(failureState, 'loading', false);
      _.set(failureState, 'mutationStatus.condolence', 0);

      return failureState;

    case RESET_MUTATION_STATUS:
      const resetState = _.cloneDeep(state);

      _.set(resetState, 'loading', false);
      _.set(resetState, 'mutationStatus.condolence', null);

      return resetState;

    case MUTATE_CONDOLENCE_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newCondolenceState = _.cloneDeep(state);

      if (
        _.get(
          action,
          'response.data.addCondolence.addCondolenceResponse.entryId'
        )
      ) {
        _.set(
          newCondolenceState,
          'mutationStatus.condolence',
          action.response.data.addCondolence.addCondolenceResponse.entryId
        );
      } else {
        _.set(newCondolenceState, 'mutationStatus.condolence', 0);
      }

      return newCondolenceState;

    case MUTATE_PERSON_ALERT_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newAlertState = _.cloneDeep(state);

      if (
        _.get(action, 'response.data.addPersonAlert.addAlertResponse.alertId')
      ) {
        _.set(
          newAlertState,
          'mutationStatus.alert',
          action.response.data.addPersonAlert.addAlertResponse.alertId
        );
      } else {
        _.set(newAlertState, 'mutationStatus.alert', 0);
      }

      return newAlertState;

    case MUTATE_PERSON_ALERT_FAILURE:
      console.log(
        'a person alert mutation failure has occured...',
        action.reason
      );

      return state;

    /* istanbul ignore next */
    // not currently used
    case QUERY_LOCATION_SEARCH_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newLocationSearchState = _.cloneDeep(state);
      const result = _.get(action, 'response.data.locationSearch');

      _.set(newLocationSearchState, 'locationSearch', result);

      return newLocationSearchState;

    /* istanbul ignore next */
    // not currently used
    case MUTATE_PERSON_UGC_SUCCESS:
      console.log('UCG mutation success', action.response);

      return state;

    /* istanbul ignore next */
    // not currently used
    case MUTATE_PERSON_UGC_FAILURE:
      console.log('UGC mutation failure...', action.reason);

      return state;
    case MUTATE_LIKES_SUCCESS:
      if (!action.response) {
        return state;
      }

      const newLikeState = _.cloneDeep(state);
      const id = _.get(
        action,
        'response.data.incrementCondolenceLike.incrementCondolenceLikeResponse.condolenceId'
      );
      const count = _.get(
        action,
        'response.data.incrementCondolenceLike.incrementCondolenceLikeResponse.likes'
      );
      const condolences = _.get(
        newLikeState,
        'person.guestBook.condolences.edges',
        []
      );
      const condolenceIndex = _.findIndex(
        condolences,
        item => item.node.condolenceId === id
      );

      if (condolenceIndex !== -1) {
        _.set(
          newLikeState,
          `person.guestBook.condolences.edges[${condolenceIndex}].node.likes`,
          count
        );
      }

      return newLikeState;
    case MUTATE_LIKES_FAILURE:
      return state;
    case PERSON_STORE_HYDRATION:
      return {...action.data};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/personStore.js